import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="footer-dark text-white pt-16 pb-8" data-id="element-101" data-mp="3gf958x4mo89h">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-102" data-mp="3ggtwodvnbb34">
        <div className="mb-12" data-id="element-103" data-mp="32onkf2vm5o8y">
          <img src="https://cdn.magicpatterns.com/uploads/rgcJwPHo8cNW53rsocngGA/NewRiver-Logo-FC-1000x287v2.png" alt="New River Systems" className="h-10 w-auto brightness-0 invert" data-id="element-104" data-mp="32pp6e2e63v5g" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16" data-id="element-105" data-mp="3uftn9r2py01x">
          {/* Company */}
          <div data-id="element-106" data-mp="36msyjwt2ysh">
            <h4 className="font-bold text-lg mb-6 text-white font-heading" data-id="element-107" data-mp="3lecb2jsfmiii">
              COMPANY
            </h4>
            <ul className="space-y-3" data-id="element-108" data-mp="3qd6tvlqeg72m">
              <li data-id="element-109" data-mp="3qc44ji8q6cot">
                <Link to="/about-us" className="text-nrs-light hover:text-white transition-colors" data-id="element-110" data-mp="3qfjighqnxfon">
                  About New River
                </Link>
              </li>
              <li data-id="element-111" data-mp="2ez1joazlf0yu">
                <Link to="/about-us/our-team" className="text-nrs-light hover:text-white transition-colors" data-id="element-112" data-mp="2ezl4q0kji5h3">
                  Leadership
                </Link>
              </li>
              <li data-id="element-113" data-mp="3gbqy0fcwslaw">
                <Link to="/about-us/partners" className="text-nrs-light hover:text-white transition-colors" data-id="element-114" data-mp="3gcaahgjsihhj">
                  Partners
                </Link>
              </li>
              <li data-id="element-115" data-mp="3q7u3nv6yz22l">
                <Link to="/about-us/community" className="text-nrs-light hover:text-white transition-colors" data-id="element-116" data-mp="3q7bwi3irr3fw">
                  Community
                </Link>
              </li>
              <li data-id="element-117" data-mp="335tdib8plh0">
                <Link to="/about-us/certifications" className="text-nrs-light hover:text-white transition-colors" data-id="element-118" data-mp="33noucq2vvnv">
                  Certifications
                </Link>
              </li>
              <li data-id="element-119" data-mp="cu8qk911tgb0">
                <Link to="/about-us/contract-vehicles" className="text-nrs-light hover:text-white transition-colors" data-id="element-120" data-mp="cvtlw0v6t39x">
                  Contracts
                </Link>
              </li>
              <li data-id="element-121" data-mp="mtraipgyl232">
                <Link to="/careers" className="text-nrs-light hover:text-white transition-colors" data-id="element-122" data-mp="mq3jpy2wets1">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-123" data-mp="13sr1ynmmotog">
            <h4 className="font-bold text-lg mb-6 text-white font-heading" data-id="element-124" data-mp="13s9a037011mc">
              SERVICES
            </h4>
            <ul className="space-y-3" data-id="element-125" data-mp="18ksl8ti7rknz">
              <li data-id="element-126" data-mp="1clmbvun1jdkk">
                <Link to="/services/servicenow" className="text-nrs-light hover:text-white transition-colors" data-id="element-127" data-mp="1cm450ieepbo9">
                  ServiceNow
                </Link>
              </li>
              <li data-id="element-128" data-mp="1mjsc87t78bnb">
                <Link to="/services/identity-access-management" className="text-nrs-light hover:text-white transition-colors" data-id="element-129" data-mp="1mj8v2tbdhrac">
                  ICAM Services
                </Link>
              </li>
              <li data-id="element-130" data-mp="3obolfarw99ex">
                <Link to="/services/program-and-project-management" className="text-nrs-light hover:text-white transition-colors" data-id="element-131" data-mp="3oc6r0y0g4zzi">
                  Program Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-132" data-mp="25onds1nk19v5">
            <h4 className="font-bold text-lg mb-6 text-white font-heading" data-id="element-133" data-mp="25o57sdb3bha1">
              RESOURCES
            </h4>
            <ul className="space-y-3" data-id="element-134" data-mp="21nlc7e660lq0">
              <li data-id="element-135" data-mp="21kfmpxtmjhtr">
                <Link to="/services/servicenow/thought-leadership" className="text-nrs-light hover:text-white transition-colors" data-id="element-136" data-mp="1wnz1bbdt7hkd">
                  Blog
                </Link>
              </li>
              <li data-id="element-137" data-mp="2pcea3g6cl3n9">
                <Link to="/services/servicenow/case-studies" className="text-nrs-light hover:text-white transition-colors" data-id="element-138" data-mp="2pc4l9vx1h2j5">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-139" data-mp="2feq5zzmuqjsf">
                <Link to="/services/servicenow/calculator" className="text-nrs-light hover:text-white transition-colors" data-id="element-140" data-mp="2fd5d0eg6r8wo">
                  Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-141" data-mp="141e61zu7qlbj">
            <h4 className="font-bold text-lg mb-6 text-white font-heading" data-id="element-142" data-mp="2rvzl1938jxrl">
              CONNECT
            </h4>
            <ul className="space-y-3" data-id="element-143" data-mp="2wmppmk3u7wl8">
              <li data-id="element-144" data-mp="2wnr1urwlap4j">
                <a href="#" className="text-nrs-light hover:text-white transition-colors" data-id="element-145" data-mp="2woamwhhjdtms">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-146" data-mp="2nuxkmoxl1fo1">
                <Link to="/contact-us" className="text-nrs-light hover:text-white transition-colors" data-id="element-147" data-mp="2nue1x603yn8y">
                  Email
                </Link>
              </li>
            </ul>
            <div className="mt-8 space-y-2 text-nrs-light text-sm" data-id="element-148" data-mp="3fk0r8bcxz23u">
              <p data-id="element-149" data-mp="31m2cv5ymf5oc">Email: info@newriversystems.com</p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-nrs-light" data-id="element-150" data-mp="36k44wge0yfby">
          <p data-id="element-151" data-mp="1q4swisasgtr9">© 2026 New River Systems Corporation</p>
          <div className="flex items-center gap-4" data-id="element-152" data-mp="1v601kjljreu8">
            <a href="#" className="hover:text-white transition-colors" data-id="element-153" data-mp="1v6s0o4ecrup9">
              Privacy Policy
            </a>
            <span data-id="element-154" data-mp="1nnsg3vf5nx4b">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-155" data-mp="1ine6i8xwof46">
              Terms of Use
            </a>
            <span data-id="element-156" data-mp="1wmw154xvumlg">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-157" data-mp="1wm43zpon0gt2">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}